import React, { useMemo } from "react";
import CreateMissionFees from "../../../screens/create-mission/CreateMissionFees";
import VStack from "../../../ui_atoms/VStack";
import { MockedProvider } from "@apollo/client/testing/react";
import type { Meta, StoryObj } from "@storybook/react";
import CreateMissionsManager from "../../../contexts/CreateMissionManager";
import { buildContract, buildMission } from "../../factories";
import {
    EarningType,
    FeeType,
    Repetition,
    RepetitionType,
    Unit,
} from "../../../__generated__/graphql";
import { newMissionState } from "../../../atoms/core";
import { AtomsHydrator } from "../../../atoms/atoms-hydrator";

type RepetitionMode = "With" | "Without";

function InnerStory() {
    return (
        <MockedProvider mocks={[]}>
            <VStack gap={1} style={{ alignItems: "stretch", alignSelf: "stretch", flex: 1 }}>
                <CreateMissionsManager
                    onValidate={(mission) => {
                        alert(
                            `Screen Validated fee count: ${mission.currentContract?.fees?.length}`,
                        );
                    }}
                >
                    <CreateMissionFees />
                </CreateMissionsManager>
            </VStack>
        </MockedProvider>
    );
}

function StoryComponent({ repetitionMode }: { repetitionMode: RepetitionMode }) {
    const mission = useMemo(
        () =>
            buildMission({
                currentContract: buildContract({
                    earningType:
                        repetitionMode == "With" ? EarningType.Hourly : EarningType.Package,
                    workingTimeClassicSpec:
                        repetitionMode === "Without"
                            ? {
                                  repetition: Repetition.None,
                                  unit: Unit.Hours,
                                  unitCount: 20,
                                  dailyHours: null,
                              }
                            : {
                                  repetition: Repetition.Week,
                                  unit: Unit.Hours,
                                  unitCount: 42,
                                  dailyHours: null,
                              },
                    fees: [
                        {
                            id: "1",
                            type: FeeType.PrivateTransport,
                            amount: 1800,
                            invoiceAmount: 1944,
                            repetition: RepetitionType.WorkedMonth,
                            isAvsSalaryExempt: false,
                            countUnit: null,
                            externalId: null,
                            otherTitle: null,
                        },
                        {
                            id: "2",
                            type: FeeType.Other,
                            otherTitle: "Chaussettes de ski",
                            amount: 3000,
                            invoiceAmount: 3240,
                            repetition: RepetitionType.Count,
                            isAvsSalaryExempt: false,
                            countUnit: null,
                            externalId: null,
                        },
                    ],
                }),
            }),
        [repetitionMode],
    );
    return (
        <AtomsHydrator atomValues={[[newMissionState, mission]]}>
            <MockedProvider mocks={[]}>
                <InnerStory />
            </MockedProvider>
        </AtomsHydrator>
    );
}

const meta = {
    title: "CreateMission/Fees",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const WithRepetition: Story = {
    args: {
        repetitionMode: "With",
    },
};
export const NoRepetition: Story = {
    args: {
        repetitionMode: "Without",
    },
};
